module.exports = __webpack_public_path__ + "img/p13_03.118ee869.png";